// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__jZFRr","clinicsSelect":"TableHeading_clinicsSelect__3JgYj"};